"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelfServiceUpdateCustomer = void 0;
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var error_helper_const_1 = require("@src/const/error-handling/error-helper.const");
var input_output_helper_const_1 = require("@src/const/input-output-helper.const");
var translation_1 = __importDefault(require("@src/services/translation"));
var self_service_helper_1 = require("./self-service.helper");
var self_service_service_1 = require("./self-service.service");
var _SelfServiceCustomerDataMapping = {
    username: {
        uid: 'customer.username',
        type: 'text',
    },
    firstname: {
        uid: 'customer.firstname',
        type: 'text',
    },
    lastname: {
        uid: 'customer.lastname',
        type: 'text',
    },
    email: {
        uid: 'customer.email',
        type: 'text',
    },
    telephone_mobile: {
        uid: 'customer.telephone_mobile',
        type: 'text',
    },
    gender: {
        uid: 'customer.gender',
        type: 'radio',
    },
    street: {
        uid: 'customer.street',
        type: 'text',
    },
    houseNumber: {
        uid: 'customer.houseNumber',
        type: 'text',
    },
    zipCode: {
        uid: 'customer.zipCode',
        type: 'text',
    },
    city: {
        uid: 'customer.city',
        type: 'text',
    },
    countryCode: {
        uid: 'customer.countryCode',
        type: 'text',
    },
};
var SelfServiceUpdateCustomer = /** @class */ (function () {
    function SelfServiceUpdateCustomer() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
    }
    SelfServiceUpdateCustomer.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var selfServiceData, individualWithOptions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        (0, generator_const_1._HideErrorMessage)();
                        (0, error_helper_const_1._HideSuccessMessage)();
                        selfServiceData = (0, self_service_helper_1.loadSelfServiceToken)();
                        if (!selfServiceData)
                            return [2 /*return*/];
                        this.selfServiceData = selfServiceData;
                        (0, generator_const_1._CreateLoadingScreen)();
                        return [4 /*yield*/, self_service_service_1.SelfServiceService.getSelfServiceIndividual(selfServiceData.ssid, this.config)];
                    case 1:
                        individualWithOptions = _a.sent();
                        (0, generator_const_1._DeleteLoadingScreen)();
                        if ('errorMessage' in individualWithOptions) {
                            (0, self_service_helper_1.hideModuleContentAndShowError)(this.$container, individualWithOptions.errorMessage);
                            return [2 /*return*/];
                        }
                        this.individual = individualWithOptions.individual;
                        return [4 /*yield*/, (0, self_service_helper_1.replaceIndividualPlaceholders)(this.$container, individualWithOptions)];
                    case 2:
                        _a.sent();
                        this.fillCustomerData(individualWithOptions);
                        this.registerSubmitButton();
                        return [2 /*return*/];
                }
            });
        });
    };
    SelfServiceUpdateCustomer.prototype.fillCustomerData = function (individualWithOptions) {
        var individual = individualWithOptions.individual;
        for (var key in _SelfServiceCustomerDataMapping) {
            var field = _SelfServiceCustomerDataMapping[key];
            var value = this.getCustomerDisplayValue(individual, field.uid);
            (0, input_output_helper_const_1._WriteField)(field, value, this.$container);
        }
    };
    SelfServiceUpdateCustomer.prototype.registerSubmitButton = function () {
        var _this = this;
        var submitButton = this.$container.find('[data-action="update-customer"]').first();
        if (!submitButton.length)
            return;
        var btn = submitButton[0];
        btn.setAttribute('data-allow-action', 'true');
        btn.addEventListener('click', function (event) { return __awaiter(_this, void 0, void 0, function () {
            var payload, updateResult;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        event.preventDefault();
                        if (btn.getAttribute('data-allow-action') === 'false')
                            return [2 /*return*/];
                        (0, generator_const_1._HideErrorMessage)();
                        (0, error_helper_const_1._HideSuccessMessage)();
                        if (!this.selfServiceData) {
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('Session expired.'));
                            return [2 /*return*/];
                        }
                        btn.disabled = true;
                        btn.setAttribute('data-allow-action', 'false');
                        (0, generator_const_1._CreateLoadingScreen)();
                        payload = this.buildPayload(this.selfServiceData.ssid);
                        if (!this.payloadHasChanges(payload)) {
                            (0, generator_const_1._DeleteLoadingScreen)();
                            (0, error_helper_const_1._ShowSuccessMessage)(translation_1.default.t('No customer data changed.'));
                            btn.disabled = false;
                            btn.setAttribute('data-allow-action', 'true');
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, self_service_service_1.SelfServiceService.updateCustomerData(payload, this.config)];
                    case 1:
                        updateResult = _d.sent();
                        (0, generator_const_1._DeleteLoadingScreen)();
                        if ('errorMessage' in updateResult) {
                            (0, generator_const_1._ShowErrorMessage)(translation_1.default.t(updateResult.errorMessage));
                            btn.disabled = false;
                            btn.setAttribute('data-allow-action', 'true');
                            return [2 /*return*/];
                        }
                        if ((_c = (_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.selfService) === null || _b === void 0 ? void 0 : _b.redirectUrlOnSuccess) === null || _c === void 0 ? void 0 : _c.length) {
                            window.location.href = this.config.get.selfService.redirectUrlOnSuccess;
                            return [2 /*return*/];
                        }
                        (0, error_helper_const_1._ShowSuccessMessage)(translation_1.default.t('Request to update your data has been successfully submitted.'));
                        btn.disabled = false;
                        btn.setAttribute('data-allow-action', 'true');
                        return [2 /*return*/];
                }
            });
        }); });
    };
    SelfServiceUpdateCustomer.prototype.buildPayload = function (ssid) {
        var payload = {
            ssid: ssid,
        };
        var address = {};
        for (var key in _SelfServiceCustomerDataMapping) {
            var field = _SelfServiceCustomerDataMapping[key];
            var value = (0, input_output_helper_const_1._ReadField)(field, this.$container, 'set');
            if (value === undefined || value === null)
                continue;
            var newValue = value.trim();
            if (newValue === '')
                continue;
            if (!this.customerValueChanged(field.uid, newValue)) {
                continue;
            }
            switch (field.uid) {
                case 'customer.username':
                    payload.username = newValue;
                    break;
                case 'customer.firstname':
                    payload.givenName = newValue;
                    break;
                case 'customer.lastname':
                    payload.familyName = newValue;
                    break;
                case 'customer.email':
                    payload.email = newValue;
                    break;
                case 'customer.telephone_mobile':
                    payload.phone = newValue;
                    break;
                case 'customer.gender':
                    if (this.isFittecGender(newValue)) {
                        payload.gender = newValue;
                    }
                    else {
                        console.warn('Unsupported customer gender value:', newValue);
                    }
                    break;
                case 'customer.street':
                    address.street = newValue;
                    break;
                case 'customer.houseNumber':
                    address.houseNumber = newValue;
                    break;
                case 'customer.zipCode':
                    address.zipCode = newValue;
                    break;
                case 'customer.city':
                    address.city = newValue;
                    break;
                case 'customer.countryCode':
                    address.countryCode = newValue;
                    break;
                default:
                    console.warn('Unsupported customer data-set key:', field.uid);
                    break;
            }
        }
        if (this.addressHasAnyValue(address)) {
            payload.address = address;
        }
        return payload;
    };
    SelfServiceUpdateCustomer.prototype.customerValueChanged = function (key, newValue) {
        if (!this.individual)
            return true;
        var oldValue = this.getCustomerDisplayValue(this.individual, key).trim();
        return oldValue !== newValue.trim();
    };
    SelfServiceUpdateCustomer.prototype.payloadHasChanges = function (payload) {
        if (payload.username !== undefined)
            return true;
        if (payload.givenName !== undefined)
            return true;
        if (payload.familyName !== undefined)
            return true;
        if (payload.email !== undefined)
            return true;
        if (payload.phone !== undefined)
            return true;
        if (payload.gender !== undefined)
            return true;
        return this.addressHasAnyValue(payload.address);
    };
    SelfServiceUpdateCustomer.prototype.getCustomerDisplayValue = function (individual, key) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        var member = individual.member;
        switch (key) {
            case 'customer.username':
                return (_b = (_a = individual.personalData) === null || _a === void 0 ? void 0 : _a.username) !== null && _b !== void 0 ? _b : '';
            case 'customer.firstname':
                return (_c = individual === null || individual === void 0 ? void 0 : individual.givenName) !== null && _c !== void 0 ? _c : '';
            case 'customer.lastname':
                return (_d = individual === null || individual === void 0 ? void 0 : individual.familyName) !== null && _d !== void 0 ? _d : '';
            case 'customer.email':
                return (_e = individual === null || individual === void 0 ? void 0 : individual.email) !== null && _e !== void 0 ? _e : '';
            case 'customer.telephone_mobile':
                return (_f = individual === null || individual === void 0 ? void 0 : individual.phone) !== null && _f !== void 0 ? _f : '';
            case 'customer.gender':
                return (_g = individual === null || individual === void 0 ? void 0 : individual.gender) !== null && _g !== void 0 ? _g : '';
            case 'customer.street':
                return (_j = (_h = member === null || member === void 0 ? void 0 : member.address) === null || _h === void 0 ? void 0 : _h.street) !== null && _j !== void 0 ? _j : '';
            case 'customer.houseNumber':
                return (_l = (_k = member === null || member === void 0 ? void 0 : member.address) === null || _k === void 0 ? void 0 : _k.houseNumber) !== null && _l !== void 0 ? _l : '';
            case 'customer.zipCode':
                return (_o = (_m = member === null || member === void 0 ? void 0 : member.address) === null || _m === void 0 ? void 0 : _m.postalCode) !== null && _o !== void 0 ? _o : '';
            case 'customer.city':
                return (_q = (_p = member === null || member === void 0 ? void 0 : member.address) === null || _p === void 0 ? void 0 : _p.city) !== null && _q !== void 0 ? _q : '';
            case 'customer.countryCode':
                return (_s = (_r = member === null || member === void 0 ? void 0 : member.address) === null || _r === void 0 ? void 0 : _r.countryCode) !== null && _s !== void 0 ? _s : '';
            default:
                console.warn('Unsupported customer data-get/data-set key:', key);
                return '';
        }
    };
    SelfServiceUpdateCustomer.prototype.addressHasAnyValue = function (address) {
        if (!address)
            return false;
        for (var key in address) {
            if (!Object.prototype.hasOwnProperty.call(address, key))
                continue;
            var value = address[key];
            if (value !== undefined && value !== '') {
                return true;
            }
        }
        return false;
    };
    SelfServiceUpdateCustomer.prototype.isFittecGender = function (value) {
        return value === 'MALE' || value === 'FEMALE' || value === 'UNISEX';
    };
    return SelfServiceUpdateCustomer;
}());
exports.SelfServiceUpdateCustomer = SelfServiceUpdateCustomer;
